import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  InputAdornment,
  Skeleton,
  IconButton,
} from "@mui/material";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import WhatsApps from "../../../../../assets/images/watsapp.png";
import Facebooks from "../../../../../assets/images/facebook.png";
import InstagramIcon from "../../../../../assets/images/instagram.png";
import YouTubeIcon from "../../../../../assets/images/youtube.png";
import LinkedInIcon from "../../../../../assets/images/linkdin.png";
import PinterestIcon from "../../../../../assets/images/pintrest.png";
import LanguageIcon from "../../../../../assets/images/website.png";
import LocationOnIcon from "../../../../../assets/images/google review.png";
import TelegramIcon from "../../../../../assets/images/telegram.png";
import TwitterIcon from "../../../../../assets/images/x.png";
import PictureAsPdfIcon from "../../../../../assets/images/pdf.png";
import snapchatIcon from "../../../../../assets/images/snapchat.png";
import LoaderCon from "../../../../../components/ui/LoaderContainer";
import mobileIcon from "../../../../../assets/images/mobile.png";
import skypIcon from "../../../../../assets/images/skype.png";
import massengerIcon from "../../../../../assets/images/massenger.png";
import wechatIcon from "../../../../../assets/images/wechat-logo-png-transparent.png";
import FaceTimeIcon from "../../../../../assets/images/facetime-ios.png";
import { Link, useNavigate } from "react-router-dom";
import { Add, CloseCircle, Edit } from "iconsax-react";
import Snackbar1 from "../../../../../components/ui/Snackbar";

const socialFields = [
  { label: "Facebook Link", key: "Facebook", type: "text", icon: Facebooks },
  {
    label: "Instagram Link",
    key: "Instagram",
    type: "text",
    icon: InstagramIcon,
  },
  {
    label: "WhatsApp Number",
    key: "WhatsApp",
    type: "number",
    icon: WhatsApps,
  },
  { label: "Browser Link", key: "Browser", type: "text", icon: LanguageIcon },
  { label: "Snapchat Link", key: "Snapchat", type: "text", icon: snapchatIcon },
  { label: "Twitter Link", key: "Twitter", type: "text", icon: TwitterIcon },
  { label: "LinkedIn Link", key: "LinkedIn", type: "text", icon: LinkedInIcon },
  { label: "Telegram Link", key: "Telegram", type: "text", icon: TelegramIcon },
  { label: "YouTube Link", key: "YouTube", type: "text", icon: YouTubeIcon },
  {
    label: "Pinterest Link",
    key: "Pinterest",
    type: "text",
    icon: PinterestIcon,
  },
  {
    label: "PDF Downloader Link",
    key: "PDFDownloader",
    type: "text",
    icon: PictureAsPdfIcon,
  },
  { label: "Mobile Number", key: "mobile", type: "number", icon: mobileIcon },
  { label: "Skype Link", key: "Skype", type: "text", icon: skypIcon },
  {
    label: "Messenger Link",
    key: "massenger",
    type: "text",
    icon: massengerIcon,
  },
  { label: "Wechat Link", key: "wechat", type: "text", icon: wechatIcon },
  {
    label: "FaceTime Number",
    key: "FaceTime",
    type: "number",
    icon: FaceTimeIcon,
  },
  {
    label: "Google Review Link",
    key: "GoogleMaps",
    type: "text",
    icon: LocationOnIcon,
  },
];

const socialPlatforms = {
  GoogleMaps: { label: "Google Review", icon: LocationOnIcon },
  Instagram: { label: "Instagram", icon: InstagramIcon },
  Browser: { label: "Website", icon: LanguageIcon },
  WhatsApp: {
    label: "WhatsApp",
    icon: WhatsApps,
    linkPrefix: "https://wa.me/",
    sanitize: (val) => {
      const cleaned = val.replace(/[^\d]/g, "");
      return cleaned.startsWith("91") ? cleaned : "91" + cleaned;
    },
  },
  mobile: {
    label: "Mobile",
    icon: mobileIcon,
    linkPrefix: "tel:",
    sanitize: (val) => val.replace(/[^\d]/g, ""),
  },
  Twitter: { label: "Twitter", icon: TwitterIcon },
  LinkedIn: { label: "LinkedIn", icon: LinkedInIcon },
  Facebook: { label: "Facebook", icon: Facebooks },
  massenger: { label: "Messenger", icon: massengerIcon },
  YouTube: { label: "YouTube", icon: YouTubeIcon },
  Telegram: { label: "Telegram", icon: TelegramIcon },
  Snapchat: { label: "Snapchat", icon: snapchatIcon },
  PDFDownloader: { label: "PDF Downloader", icon: PictureAsPdfIcon },
  Pinterest: { label: "Pinterest", icon: PinterestIcon },
  FaceTime: {
    label: "FaceTime",
    icon: FaceTimeIcon,
    linkPrefix: "tel:",
    sanitize: (val) => val.replace(/[^\d]/g, ""),
  },
  wechat: { label: "Wechat", icon: wechatIcon },
  Skype: { label: "Skype", icon: skypIcon },
};

export default function AdminPage({
  close_snack_bar,
  snackbar,
  client,
  login,
  UploadaddLink,
  onLogout,
  viewLinkById,
}) {
  const navigate = useNavigate();
  const [add, setAdd] = useState(false);
  const [formData, setFormData] = useState({});
  const [coverPreview, setCoverPreview] = useState(null);
  const [profilePreview, setProfilePreview] = useState(null);
  const [showAllReviews, setShowAllReviews] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [coverImage, setCoverImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errors] = useState({});

  // ✅ Sets background color on mount
  useEffect(() => {
    document.body.style.background = "rgba(3, 22, 52, 0.1)";
  }, []);

  // ✅ Load link data once
  useEffect(() => {
    if (login.token && login.user_id) {
      viewLinkById(login.user_id, login.token);
    }
  }, [login.token, login.user_id, viewLinkById]);

  // ✅ Set loading to false when data is fetched
  useEffect(() => {
    if (client.allLinksByAdmin) {
      setLoading(false);
    }
  }, [client.allLinksByAdmin]);

  // ✅ Set Add form open if no links exist, prevent loop
  useEffect(() => {
    if (!loading) {
      const isEmpty =
        client.allLinksByAdmin &&
        Object.keys(client.allLinksByAdmin).length === 0;

      setAdd((prev) => {
        const shouldShowForm = isEmpty;
        if (prev !== shouldShowForm) {
          return shouldShowForm;
        }
        return prev;
      });
    }
  }, [loading, client.allLinksByAdmin]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const isFormValid =
    coverImage instanceof File &&
    profileImage instanceof File &&
    !!(coverImage?.name && profileImage?.name) &&
    typeof formData?.heading === "string" &&
    formData.heading.trim() !== "";

  const maxSize = 5 * 1024 * 1024; // 5MB

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const supportedImageTypes = ["image/jpeg", "image/png", "image/gif"];
    const supportedVideoTypes = ["video/mp4", "video/webm"];
    const supportedCoverTypes = [
      ...supportedImageTypes,
      ...supportedVideoTypes,
    ];

    if (file.size > maxSize) {
      alert("File size must not exceed 5MB.");
      return;
    }

    if (
      (type === "profile" && !supportedImageTypes.includes(file.type)) ||
      (type === "cover" && !supportedCoverTypes.includes(file.type))
    ) {
      alert("Unsupported file type. Please upload a valid image or video.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const result = event.target.result;

      if (type === "profile") {
        setProfileImage(file);
        setProfilePreview(result);
      } else if (type === "cover") {
        setCoverImage(file);
        setCoverPreview({
          src: result,
          type: file.type.startsWith("image") ? "image" : "video",
        });
      }
    };

    reader.readAsDataURL(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const normalizedData = {};
    [
      "Facebook",
      "Instagram",
      "WhatsApp",
      "Browser",
      "Snapchat",
      "GoogleMaps",
      "Twitter",
      "LinkedIn",
      "Telegram",
      "YouTube",
      "Pinterest",
      "PDFDownloader",
      "heading",
      "mobile",
      "BusinessWhatsApp",
      "Skype",
      "massenger",
      "wechat",
      "FaceTime",
      "tagLine",
    ].forEach((key) => {
      normalizedData[key] = formData[key]?.trim?.() || "";
    });

    UploadaddLink(
      login.token,
      login.user_id,
      normalizedData.Facebook,
      normalizedData.Instagram,
      normalizedData.WhatsApp,
      normalizedData.Browser,
      normalizedData.Snapchat,
      normalizedData.GoogleMaps,
      normalizedData.Twitter,
      normalizedData.LinkedIn,
      normalizedData.Telegram,
      normalizedData.YouTube,
      normalizedData.Pinterest,
      normalizedData.PDFDownloader,
      profileImage,
      coverImage,
      normalizedData.heading,
      coverPreview?.type,
      normalizedData.mobile,
      normalizedData.BusinessWhatsApp,
      normalizedData.Skype,
      normalizedData.massenger,
      normalizedData.wechat,
      normalizedData.FaceTime,
      showAllReviews,
      normalizedData.tagLine,
      login.login_id
    );

    setAdd(false);
  };

  const handleButtonClick = (e, option) => {
    e.preventDefault();
    if (option.label === "Mobile" || option.label === "Face Time") {
      window.location.href = option.href;
    } else {
      let url = option.href;
      if (url && !url.startsWith("http://") && !url.startsWith("https://")) {
        url = `https://${url}`;
      }
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    }
  };

  const allLinks = client.allLinksByAdmin || {};
  const imgLoading = false;

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          p: 1,
          textAlign: "center",
        }}
      >

        {client.allLinksByAdmin &&
          Object.keys(client.allLinksByAdmin).length === 0 && (
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  setAdd(true);
                  setCoverImage(null);
                  setProfileImage(null);
                  setProfilePreview("");
                  setCoverPreview("");
                }}
                sx={{
                  backgroundColor: "#031634",
                  color: "#fff",
                  boxShadow: "0 4px 14px 0 rgba(0,0,0,0.39)",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#042048",
                    transform: "scale(1.02)",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.23)",
                  },
                  textTransform: "none",
                  fontSize: 14,
                  fontWeight: 600,
                  borderRadius: 3,
                  px: 4,
                  py: 1,
                }}
                startIcon={<Add size="20" />}
                aria-label={`Add Links`}
              >
                Add Links
              </Button>
            </Grid>
          )}


        <Typography
          variant="h4"
          sx={{
            color: "#000",
            fontSize: { xs: "1.8rem", sm: "2rem", md: "2.5rem" },
          }}
        >
          {allLinks.heading || "Welcome to tapx digital.com"}
        </Typography>
        <Typography
          sx={{
            color: "#000",
            fontSize: { xs: "1.5rem", sm: "1.2rem" },
          }}
        >
          {allLinks.tagLine || ""}
        </Typography>


        <Button
          variant="contained"
          component={Link}
          to="/edit-links"
          sx={{
            backgroundColor: "#031634",
            boxShadow: "0 4px 14px 0 rgba(0,0,0,0.39)",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: "#042048",
              transform: "translateY(-1px)",
              boxShadow: "0 6px 20px rgba(0,0,0,0.23)",
            },
            textTransform: "none",
            fontSize: 14,
            fontWeight: 600,
            borderRadius: 3,
            px: 4,
            py: 1,
            mb: 2,
          }}
          startIcon={<Edit size="20" />}
          aria-label={`Edit Links`}
        >
          Edit Links
        </Button>


        <Grid container justifyContent="center" spacing={3}>
          <Grid item xs={12} sm={10} md={8}>
            <Box position="relative">
              {allLinks.mediaType === "video" ? (
                <Box
                  component="video"
                  src={allLinks.coverImage}
                  sx={{
                    width: "100%",
                    borderRadius: 2,
                    maxHeight: "250px",
                    objectFit: "cover",
                  }}
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls={false}
                />
              ) : allLinks.mediaType === "image" ? (
                <>
                  {imgLoading && (
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={250}
                      sx={{ borderRadius: 2 }}
                    />
                  )}
                  <Box
                    component="img"
                    src={allLinks.coverImage}
                    alt="Cover"
                    onLoad={() => { }}
                    sx={{
                      width: "100%",
                      borderRadius: 2,
                      maxHeight: "250px",
                      objectFit: "cover",
                      display: imgLoading ? "none" : "block",
                    }}
                  />
                </>
              ) : (
                <Box
                  component="video"
                  src="https://firebasestorage.googleapis.com/v0/b/qrcodecustomer.firebasestorage.app/o/uploads%2FBoost%20your%20business%20visibility%20with%20just%20a%20tap%20or%20scan-2.mp4-m2ytuynfl?alt=media&token=a7daa381-c05c-41de-a3e4-8a166931c169"
                  sx={{
                    width: "100%",
                    borderRadius: 2,
                    maxHeight: "250px",
                    objectFit: "cover",
                  }}
                  autoPlay
                  muted
                  loop
                  playsInline
                  controls={false}
                />
              )}


              <Avatar
                src={
                  allLinks.profileImage ||
                  "https://firebasestorage.googleapis.com/v0/b/qrcodecustomer.firebasestorage.app/o/uploads%2Ftapxlogobalck.png-e5rekedqt?alt=media&token=6eb1f468-ed6c-4bbd-b367-3d9e0dbd3655"
                }
                sx={{
                  width: { xs: 80, sm: 120, md: 160 },
                  height: { xs: 80, sm: 120, md: 160 },
                  position: "absolute",
                  bottom: { xs: "-40px", sm: "-50px", md: "-60px" },
                  left: "50%",
                  transform: "translateX(-50%)",
                  border: "2px solid white",
                  zIndex: 2,
                }}
              />
            </Box>
          </Grid>
        </Grid>


        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            mt: 8,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "#000",
              fontSize: { xs: "1.2rem", sm: "1.5rem" },
              mb: 2,
            }}
          >
            Select your preferred option.
          </Typography>
        </Box>


        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{
            px: { xs: 0, sm: 5, md: 10 },
            width: "100%",
            maxWidth: "1200px",
            mx: "auto",
          }}
        >
          {Object.entries(socialPlatforms)
            .filter(([key]) => !!allLinks[key])
            .map(([key, { label, icon, linkPrefix = "", sanitize }], index) => {
              const value = allLinks[key];
              const href = `${linkPrefix}${sanitize ? sanitize(value) : value}`;

              return (
                <Grid
                  item
                  xs={4}
                  sm={3}
                  md={2}
                  key={index}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    gap: 1,
                  }}
                >
                  <Box
                    component="img"
                    src={icon}
                    alt={label}
                    onClick={(e) => handleButtonClick(e, { icon, label, href })}
                    sx={{
                      width: 60,
                      height: 60,
                      cursor: "pointer",
                      transition: "transform 0.2s",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      color: "#000",
                      fontSize: { xs: "10px", sm: "12px", md: "13px" },
                      lineHeight: 1.2,
                      wordBreak: "break-word",
                      textAlign: "center",
                    }}
                  >
                    {label}
                  </Typography>
                </Grid>
              );
            })}
        </Grid>
      </Box>

      <Dialog
        open={add}
        fullWidth
        maxWidth="md"
        PaperProps={{
          elevation: 5,
          sx: {
            borderRadius: 4,
            backgroundImage: "none",
          },
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 3 }}>
          <Typography variant="h5" fontWeight={700}>Add Links</Typography>
          <IconButton
            onClick={() => {
              onLogout(login.token);
              navigate("/");
            }}
            sx={{ color: "text.secondary" }}
          >
            <CloseCircle size="24" />
          </IconButton>
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid container direction="column" spacing={3}>

              <Grid item>
                <Box
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: 2,
                    maxHeight: 300,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  {coverPreview?.type === "image" && (
                    <Box
                      component="img"
                      src={coverPreview.src}
                      alt="Cover"
                      sx={{ width: "100%", objectFit: "cover" }}
                    />
                  )}
                  {coverPreview?.type === "video" && (
                    <Box
                      component="video"
                      controls
                      src={coverPreview.src}
                      sx={{ width: "100%", maxHeight: 300 }}
                    />
                  )}
                  {!coverPreview && (
                    <Typography sx={{ fontStyle: "italic", color: "#888" }}>
                      No Cover Selected
                    </Typography>
                  )}
                </Box>
              </Grid>


              <Grid item>
                <TextField
                  type="file"
                  fullWidth
                  size="small"
                  accept="image/*,video/*"
                  onChange={(e) => handleFileChange(e, "cover")}
                  label={
                    <>
                      Upload Cover<span style={{ color: "red" }}> *</span>
                    </>
                  }
                  helperText="Upload a cover image or video"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>


              <Grid item>
                <Box display="flex" justifyContent="center">
                  <Avatar
                    src={profilePreview || ""}
                    sx={{ width: 120, height: 120, border: "2px solid white" }}
                  />
                </Box>
              </Grid>


              <Grid item>
                <TextField
                  type="file"
                  fullWidth
                  size="small"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, "profile")}
                  label={
                    <>
                      Upload Profile Picture
                      <span style={{ color: "red" }}> *</span>
                    </>
                  }
                  helperText="Upload a profile image"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>


              <Grid item>
                <TextField
                  label={
                    <>
                      Brand Name<span style={{ color: "red" }}> *</span>
                    </>
                  }
                  fullWidth
                  size="small"
                  value={formData.heading || ""}
                  onChange={(e) => handleChange("heading", e.target.value)}
                />
              </Grid>
              <Grid item>
                <TextField
                  label="Tag Line"
                  fullWidth
                  size="small"
                  value={formData.tagLine || ""}
                  onChange={(e) => handleChange("tagLine", e.target.value)}
                />
              </Grid>


              <Grid container item spacing={2}>
                {socialFields.map((field) => (
                  <Grid item xs={12} sm={6} key={field.key}>
                    <TextField
                      size="small"
                      fullWidth
                      variant="outlined"
                      label={field.label}
                      type={field.type}
                      value={formData[field.key] || ""}
                      error={!!errors[field.key]}
                      helperText={errors[field.key]}
                      onChange={(e) => handleChange(field.key, e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img
                              src={field.icon}
                              alt={`${field.key}Icon`}
                              style={{ width: 24, height: 24 }}
                            />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                ))}
              </Grid>


              <Grid item>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 15px",
                    border: "1px solid #ccc",
                    borderRadius: "10px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <Typography sx={{ fontSize: 14 }}>
                    Do you want to display bad reviews on your Google Review?
                  </Typography>
                  <ToggleButtonGroup
                    value={showAllReviews}
                    exclusive
                    onChange={(e, val) => setShowAllReviews(val)}
                    sx={{ ml: 2 }}
                  >
                    <ToggleButton
                      value={true}
                      sx={{
                        fontSize: 12,
                        px: 2,
                        borderRadius: 20,
                        bgcolor: showAllReviews === true ? "#4caf50" : "#fff",
                        color: showAllReviews === true ? "#fff" : "#000",
                      }}
                    >
                      Yes
                    </ToggleButton>
                    <ToggleButton
                      value={false}
                      sx={{
                        fontSize: 12,
                        px: 2,
                        borderRadius: 20,
                        bgcolor: showAllReviews === false ? "#f44336" : "#fff",
                        color: showAllReviews === false ? "#fff" : "#000",
                      }}
                    >
                      No
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={!isFormValid}
            >
              Add Links
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setAdd(false)}
            >
              Preview
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <LoaderCon />
      <Snackbar1
        open={snackbar?.response_received}
        message={snackbar?.message}
        close_snack_bar={close_snack_bar}
      />
    </Box>
  );
}
